import React from 'react';

import { DynamicIconWrapper } from '@components/common';

import { Icons } from '@icons/icons';

import { getLegendInfo } from './constants';

import styles from './LegendOokla.module.scss';

interface ILegendOoklaProps {
	measurementName: string;
	serviceLevelGood?: boolean;
	serviceLevelVariable?: boolean;
	serviceLevelNoService?: boolean;
}

const LegendOokla = ({
	measurementName,
	serviceLevelGood,
	serviceLevelVariable,
	serviceLevelNoService,
}: ILegendOoklaProps) => {
	const legendInfo = getLegendInfo(measurementName);

	const {
		title,
		textServiceLevelGood,
		textServiceLevelVariable,
		textServiceLevelNoService,
		infoServiceLevelGood,
		infoServiceLevelVariable,
		infoServiceLevelNoService,
	} = legendInfo;

	const InfoIcon = () => Icons.info({ width: 12, height: 12 });

	return (
		<div className={styles.legendContainer}>
			<div className={styles.title}>
				{title || ''}
			</div>
			{serviceLevelGood
				&& <div className={styles.serviceLevelContainer}>
					<div className={styles.markGoodLevel} />
					<div className={styles.serviceLevelText}>
						{textServiceLevelGood || ''}
					</div>
					{infoServiceLevelGood
						&& <DynamicIconWrapper
							icon={InfoIcon}
							tooltipLabel={infoServiceLevelGood}
							tooltipPlacement='left'
						/>
					}
				</div>
			}
			{serviceLevelVariable
				&& <div className={styles.serviceLevelContainer}>
					<div className={styles.markVariableLevel} />
					<div className={styles.serviceLevelText}>
						{textServiceLevelVariable || ''}
					</div>
					{infoServiceLevelVariable
						&& <DynamicIconWrapper
							icon={InfoIcon}
							tooltipLabel={infoServiceLevelVariable}
							tooltipPlacement='left'
						/>
					}
				</div>
			}
			{serviceLevelNoService
				&& <div className={styles.serviceLevelContainer}>
					<div className={styles.markNoServiceLevel} />
					<div className={styles.serviceLevelText}>
						{textServiceLevelNoService || ''}
					</div>
					{infoServiceLevelNoService
						&& <DynamicIconWrapper
							icon={InfoIcon}
							tooltipLabel={infoServiceLevelNoService}
							tooltipPlacement='left'
						/>
					}
				</div>
			}
		</div>
	);
};

export default LegendOokla;
